function scrollToReviews() {
  const reviewsFrame = document.getElementById('looxReviewsFrame');
  if (reviewsFrame) {
    reviewsFrame.scrollIntoView({ behavior: 'smooth' });
  } else {
    console.warn('Reviews frame not found');
  }
}

function toggleDetailsAccordion(prefix, productId) {
  const accordion = document.getElementById(`details-accordion-${prefix}-${productId}`);
  const button = document.querySelector(`button[onclick*="toggleDetailsAccordion('${prefix}', '${productId}')"]`);
  const showText = button?.querySelector('.show-text');
  const hideText = button?.querySelector('.hide-text');
  
  if (accordion) accordion.classList.toggle('hidden');
  if (showText) showText.classList.toggle('hidden');
  if (hideText) hideText.classList.toggle('hidden');
}

document.addEventListener('DOMContentLoaded', function () {
  const buyMenuElements = document.querySelectorAll('.buy-menu-class');
  
  buyMenuElements.forEach(element => {
    const product = JSON.parse(element.dataset.product);
    const selectedVariant = JSON.parse(element.dataset.selectedVariant);
    const disableBuyButton = JSON.parse(element.dataset.disableBuyButton);
    const bundlePurchaseType = JSON.parse(element.dataset.bundlePurchaseType);
    const variantSmallImages = JSON.parse(element.dataset.variantSmallImages);
    const variantNames = JSON.parse(element.dataset.variantNames);
    const disabledVariants = JSON.parse(element.dataset.disabledVariants);
    const selectedOptions = JSON.parse(element.dataset.selectedOptions);
    const prefix = element.dataset?.prefix;

    const { createApp } = Vue;

    createApp({
      delimiters: ['${', '}'],
      data() {
        return {
          product,
          selectedVariant,
          disableBuyButton,
          sellingPlanId: undefined,
          purchaseType: 'subscription',
          quantity: 1,
          isLoading: false,
          selectedOptions,
          bundlePurchaseType,
          variantSmallImages,
          variantNames,
          direction: null,
          glideInstance: null,
          prefix: prefix
        }
      },
      computed: {
        cart() {
          return store ? store.state.cart : undefined;
        },
        availableSellingPlans() {
          const sellingPlanIds = this.selectedVariant?.selling_plan_allocations?.map(allocation => allocation.selling_plan_id) ?? [];
          const groups = this.product?.selling_plan_groups?.filter(group => group.app_id === 'yari-flow') ?? [];
          return groups.reduce((acc, group) => {
            const plans = group.selling_plans.filter(plan => sellingPlanIds.includes(plan.id));
            return [...acc, ...plans];
          }, []);
        },
        originalPrice() {
          return this.selectedVariant?.compare_at_price || this.selectedVariant?.price;
        },
        price() {
          return this.selectedVariant.selling_plan_allocations.find(allocation => allocation.selling_plan_id === this.sellingPlanId)?.per_delivery_price;
        },
        selectedImage() {
          return this.selectedVariant?.featured_media?.preview_image.src || this.product.featured_image;
        },
        isVariantDisabled() {
          return disabledVariants.includes(this.selectedVariant?.id);
        },
        sellingPlanDiscount() {
          const compareAtPrice = this.selectedVariant?.compare_at_price || this.selectedVariant?.price;
          const perDeliveryPrice = this.price;
          return this.calculateDiscount(compareAtPrice, perDeliveryPrice);
        },
        sellingPlan() {
          return this.product.selling_plan_groups.reduce((acc, group) => {
            return [...acc, ...group.selling_plans];
          }, []).find(plan => plan.id === this.sellingPlanId);
        },
        isUKRegion() {
          return !!store?.isUK();
        }
      },
      created() {
        // Check for variant parameter in URL
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        if (variantId) {
          const variant = this.product.variants.find(v => v.id.toString() === variantId && v.available);
          if (variant) {
            this.selectedVariant = variant;
            this.selectedOptions = variant.options;
          } else this.findVariant();
        } else this.findVariant();
      },
      methods: {
        updateOptions(optionIndex, value) {
          this.selectedOptions[optionIndex] = value;
          this.findVariant();
        },
        findVariant() {
          this.selectedVariant = this.product.variants.find(variant => {
            return variant.options.every((option, index) => {
              return option === this.selectedOptions[index];
            });
          });
        },
        selectVariant(variantId) {
          this.selectedVariant = this.product.variants.find(variant => variant.id === variantId);
        },
        increment() {
          this.direction = 'decrease';
          this.quantity++;
        },
        decrement() {
          if (this.quantity > 1) {
            this.direction = 'increase';
            this.quantity--;
          }
        },
        selectPurchaseType(type) {
          this.purchaseType = type;
        },
        goToVariantImage(variant) {
          const glideElement = document.querySelector(`#${this.prefix}-glide-${this.product.id}`);
          if (glideElement && typeof Glide !== 'undefined' && variant.featured_image) {
            const slide = glideElement?.querySelector(`.glide__slide[data-image-id="${variant.featured_image.id}"]`);
            if (slide && this.glideInstance) {
              const slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
              const index = slideIndex - 2;
              this.glideInstance.go(`=${index}`);
            }
          }
        },
        getSmallImage(variantName) {
          const index = this.variantNames.findIndex(name => name.includes(variantName));
          return index !== -1 ? this.variantSmallImages[index] : null;
        },
        formatMoney(currency, value, decimals = 2) {
          return formatCurrency(currency, value, decimals);
        },
        calculateDiscount(compareAtPrice, perDeliveryPrice) {
          return Math.floor(((compareAtPrice - perDeliveryPrice) / compareAtPrice) * 100);
        },
        async addToCart() {
          this.isLoading = true;
          let formData = {
            'items': [{
              'id': this.selectedVariant?.id,
              'selling_plan': this.purchaseType === 'subscription' ? this.sellingPlanId ?? undefined : undefined,
              'quantity': this.quantity
            }]
          };
          const result = await store.addToCart(formData);
          this.isLoading = false;
          
          if (result) {
            // First close quick buy panel if it exists
            const quickBuyPanel = document.querySelector('.quick-buy:not(.hidden)');
            if (quickBuyPanel) {
              const productId = quickBuyPanel.id.split('-')[2];
              window.toggleQuickBuy(productId);
              if (!modalState.openModals.has('cart')) window.toggleCart();
            } else window.toggleCart();
          }
        },
        updateSellingPlans() {
          if (this.selectedVariant)
            this.sellingPlanId = this.selectedVariant?.selling_plan_allocations?.[0]?.selling_plan_id;
        },
      },
      mounted() {
        this.purchaseType = this.availableSellingPlans?.length > 0 ? 'subscription' : 'one-time';
        this.updateSellingPlans();

        this.$nextTick(() => {
          if (this.product.media.length > 1) {
            const glideElements = document.querySelectorAll(`#buy-menu-glide-${this.product.id}`);
            glideElements.forEach(glideElement => {
              if (glideElement && typeof Glide !== 'undefined') {
                this.glideInstance = new Glide(glideElement, {
                  type: 'carousel',
                  startAt: 0,
                  gap: 0,
                  perView: 1
                }).mount();
                this.goToVariantImage(this.selectedVariant);
              } else {
                console.warn('Glide initialization failed', {
                  element: glideElement,
                  Glide: typeof Glide
                });
              }
            });
          }
        });
      },
      watch: {
        selectedVariant: {
          handler(newVariant) {
            if (newVariant) {
              this.updateSellingPlans();
              // Go to variant image when it changes
              this.$nextTick(() => {
                this.goToVariantImage(newVariant);
              });
            }
          },
          immediate: true
        }
      }
    }).mount(element);
  });
});

window.scrollToReviews = scrollToReviews;
window.toggleDetailsAccordion = toggleDetailsAccordion; 